import React from 'react';
import { get } from 'lodash';

import SystemMessage from './SystemMessage';

import { __t, applyTranslations } from 'utils/language';

import type { Subcampaign } from 'types';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  metadata: {
    subcampaign?: Subcampaign
  },
  text: string
};

class SystemChatMessageShippingAddressSet extends SystemMessage<Props> {
  render() {
    const {
      text,
      metadata
    } = this.props;

    const shippingAddress = get(metadata, 'subcampaign.shippingAddress', null);

    return (
      <React.Fragment>
        {
          shippingAddress && shippingAddress.address1 ? (
            this.renderIcon('drop-pin-with-house-inside-circle-custom-fg')
          ) : (
            this.renderIcon('telephone-receiver-inside-circle-custom-fg')
          )
        }
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-shipping-address__bubble"
          >
            <div>
              {text}
            </div>
            {
              shippingAddress && shippingAddress.address1 &&
                <div className="messages-system-message__paragraph">
                  <div className="messages-system-message__heading">
                    {__t('system_message.shipping_address')}:
                  </div>
                  <div>{shippingAddress.recipient}</div>
                  <div>{shippingAddress.address1}</div>
                  {
                    shippingAddress.address2 &&
                      <div>{shippingAddress.address2}</div>
                  }
                  <div>{`${shippingAddress.zip} ${shippingAddress.city}`}</div>
                  {
                    shippingAddress.stateProvinceRegion &&
                      <div>{shippingAddress.stateProvinceRegion}</div>
                  }
                  <div>{shippingAddress.country}</div>
                </div>
            }
            {
              shippingAddress?.email && (
                <div className="messages-system-message__paragraph">
                  <div className="messages-system-message__heading">
                    {__t('system_message.email_address')}:
                  </div>
                  <div>{shippingAddress.email}</div>
                </div>
              )
            }
            {
              shippingAddress && shippingAddress.phone &&
                <div className="messages-system-message__paragraph">
                  <div className="messages-system-message__heading">
                    {__t('system_message.phone')}:
                  </div>
                  <div>{shippingAddress.phone}</div>
                </div>
            }
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageShippingAddressSet;
